import axios from 'axios';

// Dynamic API URL - always use aliensteam.com
const getApiUrl = () => {
  // If REACT_APP_API_URL is set (development or build-time), use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Use API path - Laravel routes are at /api/* (not /backend/api)
  return 'https://aliensteam.com/api';
};

const API_URL = getApiUrl();

// Log API URL for debugging
console.log('API Base URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // If data is FormData, remove Content-Type header to let axios set it automatically with boundary
  if (config.data instanceof FormData) {
    console.log('FormData detected, removing Content-Type header');
    delete config.headers['Content-Type'];
    // Log FormData contents for debugging
    console.log('FormData entries:');
    for (let pair of config.data.entries()) {
      console.log('  ' + pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name + ' (File)' : pair[1]));
    }
  }
  
  return config;
});

// Handle response errors and validate JSON responses
api.interceptors.response.use(
  (response) => {
    // Check if response is HTML instead of JSON (common routing issue)
    if (response.data && typeof response.data === 'string' && response.data.trim().startsWith('<!')) {
      const fullUrl = `${response.config?.baseURL}${response.config?.url}`;
      console.error('❌ API returned HTML instead of JSON');
      console.error('📍 Full URL:', fullUrl);
      console.error('⚠️ This usually means:');
      console.error('   1. Backend API is not properly configured on the server');
      console.error('   2. Server routing is redirecting API calls to React app');
      console.error('   3. Check .htaccess or server configuration');
      console.error('   4. Verify backend is deployed correctly');
      return Promise.reject(new Error(`API endpoint returned HTML. Check server configuration. URL: ${fullUrl}`));
    }
    return response;
  },
  (error) => {
    // Check if error response is HTML
    if (error.response?.data && typeof error.response.data === 'string' && error.response.data.trim().startsWith('<!')) {
      const fullUrl = `${error.config?.baseURL}${error.config?.url}`;
      console.error('❌ API error response is HTML instead of JSON');
      console.error('📍 Request URL:', fullUrl);
      console.error('⚠️ Backend API may not be properly deployed or configured');
      error.isHtmlResponse = true;
      error.message = `API returned HTML instead of JSON. URL: ${fullUrl}`;
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;











